import React, { useEffect, useState } from 'react';

const CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";

interface TextScrambleProps {
  text: string;
  scrambleOnMount?: boolean;
  scrambleOnHover?: boolean;
}

export function TextScramble({ text, scrambleOnMount = true, scrambleOnHover = true }: TextScrambleProps) {
  const [displayText, setDisplayText] = useState(scrambleOnMount ? '' : text);
  const [isScrambling, setIsScrambling] = useState(false);

  const triggerScramble = () => {
    if (isScrambling) return;
    setIsScrambling(true);

    let iteration = 0;
    const maxIterations = 15;
    
    // We want the text length to immediately match 
    const targetLength = text.length;

    const interval = setInterval(() => {
      setDisplayText(
        Array.from(text)
          .map((char, index) => {
            if (index < iteration) {
              return Array.from(text)[index];
            }
            // Preserve spaces
            if (char === ' ') return ' ';
            return CHARACTERS[Math.floor(Math.random() * CHARACTERS.length)];
          })
          .join('')
      );

      // Increase iteration faster for longer words, or just a fixed rate
      iteration += 0.6;

      if (iteration >= targetLength) {
        clearInterval(interval);
        setDisplayText(text);
        setIsScrambling(false);
      }
    }, 30);
  };

  useEffect(() => {
    if (scrambleOnMount) {
      triggerScramble();
    } else {
      setDisplayText(text);
    }
  }, [text, scrambleOnMount]);

  return (
    <span 
      onMouseEnter={scrambleOnHover ? triggerScramble : undefined}
      className={scrambleOnHover ? "whitespace-pre" : ""}
    >
      {displayText}
    </span>
  );
}
